<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item :to="{ path: '/activity_list' }">活动管理</el-breadcrumb-item>
      <el-breadcrumb-item>新增活动</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="form">
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker
          type="date"
          placeholder="开始时间"
          v-model="form.startTime"
          value-format="yyyy-MM-dd"
          style="width: 100%;">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker
          type="date"
          placeholder="结束时间"
          v-model="form.endTime"
          value-format="yyyy-MM-dd"
          style="width: 100%;">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="件数" prop="totalPrice">
        <el-input v-model="form.courseCount" type="number"></el-input>
      </el-form-item>
      <el-form-item label="单价" prop="discount">
        <el-input v-model="form.unitPrice" type="number">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" :loading="loading">立即创建</el-button>
      </el-form-item>
    </el-form>
    {{form.startTime}}
  </div>
</template>

<script type="text/ecmascript-6">
  import { addActivity } from '@/api/activity';
  import { mapGetters } from 'vuex';
  import { trimString } from '@/common/js/util';

  export default {
    name: 'add_activity',
    data() {
      return {
        form: {
          startTime: '',
          endTime: '',
          courseCount: 0,
          unitPrice: 0
        },
        rules: {
          startTime: [
            { type: 'date', required: true, message: '请选择开始时间', trigger: 'blur' }
          ],
          endTime: [
            { type: 'date', required: true, message: '请选择结束时间', trigger: 'blur' }
          ],
          courseCount: [
            { required: true, message: '请输入课程数量', trigger: 'blur' }
          ],
          unitPrice: [
            { required: true, message: '请输入单价', trigger: 'blur' }
          ]
        },
        loading: false
      };
    },
    methods: {
      onSubmit() {
        if (!this.form.startTime) {
          this.$message.warning('请选择开始时间');
          return;
        }
        if (!this.form.endTime) {
          this.$message.warning('请选择结束时间');
          return;
        }
        if (!this.form.courseCount || !trimString(this.form.courseCount)) {
          this.$message.warning('请输入课程数量');
          return;
        }
        if (!this.form.unitPrice) {
          this.$message.warning('请输入单价');
          return;
        }
        this.loading = true;
        this.form.userId = this.user.userId;
        addActivity(this.form).then((res) => {
          this.loading = false;
          if (res.rspCode === 0) {
            this.$message.success('新增成功');
            this.$router.go(-1);
          } else {
            this.$message.error(res.rspDesc);
          }
        }).catch(e => {
          this.loading = false;
        });
      }
    },
    computed: {
      ...mapGetters([
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    .title
      margin-bottom: 20px;
    .form
      width: 300px;
</style>